











import { Component, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'
import logger from '@plat-components/utils2/_esm5/logger'

import FilterNav from '../components/FilterNav.vue'
import Result from '../components/Result.vue'
import Sheets from '../components/Sheets.vue'

import { linkJump } from '../utils/common'
import { SPM_ID } from '@/utils/constants'

@Component({
  name: 'Home',
  components: {
    FilterNav,
    Result,
    Sheets,
  },
})
export default class Home extends Vue {
  @State('index') stateIndex
  get isResult() {
    return this.stateIndex === 0
  }

  mounted() {
    logger('searchlist.pv', {})
  }

  // 去纪录片首页
  toHome() {
    logger('searchlist.skip', {
      from_spmid: SPM_ID,
    })
    const link =
      'https://www.bilibili.com/blackboard/topic/activity-KOFwr2duop.html?msource=shichang'
    console.log('toHome link', link)
    linkJump(link)
  }
}
